$eve_badge $eve_surface
	variant \solid
	colors \danger
	size? \xs
	attr *
		^
		role \status
	sub /
		<= Text $eve_text
			variant \text
			colors? null
			text_variant \bodyMd
			content <= value \
